import { Component, OnInit, OnDestroy, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { BillingService } from '../../../../services/billing.service';
import { Subscription } from 'rxjs';
import { saveAs } from 'file-saver/FileSaver';
import { MatSnackBar } from '@angular/material';
import { TransactionList } from '../../../../models/transaction.model';

@Component({
    selector: 'dialog-state-exporttransaction',
    templateUrl: 'dialog.exporttransaction.html',
    styleUrls: ['dialog.exporttransaction.css']
})
export class ExportStateGovernmentTransactionDialog implements OnInit, OnDestroy {
    allSub: Subscription[] = [];
    disabledDownload: boolean = false;
    errorMessage: string = '';
    dueDate: Date = new Date();
    reportDate: Date = new Date();
    totalAmount: string = '0.00';
    modifiedBookingDate: Date = new Date();
    isModifiedBookingDate: boolean = false;
    ngrEncryption: boolean = true;
    ngr_Transaction: TransactionList;

    //Set format type
    billingFormats = [
        {
            Format_Id: 1,
            Format_Name: "New Format"
        },
        {
            Format_Id: 2,
            Format_Name: "Old Format"
        }
    ];
    selectedBillingFormat: number = this.billingFormats[0].Format_Id;

    //Download message
    downloadMessage: string = '';

    constructor(public dialogRef: MatDialogRef<ExportStateGovernmentTransactionDialog>,
        @Inject(MAT_DIALOG_DATA) public data: any,
        private billingService: BillingService,
        public snackBar: MatSnackBar) { }

    ngOnInit() {

        this.ngr_Transaction = {
            agentCode: this.data.agentCode,
            accOffCode: this.data.accOffCode,
            warrantNumber: this.data.warrantNo,
            recordStatus: this.data.recordStatus,
            paymentFrom: this.data.paymentFrom,
            paymentTo: this.data.paymentTo,
            sqlPNR: this.data.sqlPNR,
            invoiceNo: this.data.invoiceNo,
            pukalNo: null,
            travelAgent: null,
            page: null,
            isSplitBooking: null,
            PageSize: null,
            transactionType: null
        }

        let export_init_sub = this.billingService.getInitialExportTransaction(this.ngr_Transaction)
            .subscribe(
                (data) => {
                    if (typeof (data) === 'string' && data !== '0.00') {
                        this.totalAmount = data;
                    } else {
                        this.totalAmount = '0.00';

                        this.disabledDownload = true; //disabled download button & show message
                        this.downloadMessage = 'Transaction record is empty.';
                    }
                },
                error => this.errorMessage = <any>error
            );

        //Adds into array for each subscribe
        this.allSub.push(export_init_sub);
    }

    closeDialog(): void {
        this.dialogRef.close('Close');
    }

    cbOnChange(e): void {
        // console.log(e.checked);
        // console.log(this.ngr_Transaction)
    }

    billingFormatsOnChange(): void {
        if (this.selectedBillingFormat === 1) {
            this.ngrEncryption = true;
        } else if (this.selectedBillingFormat === 2) {
            this.ngrEncryption = false;
        }
    }

    modifiedBookingDateOnChange(date: Date) {
        this.modifiedBookingDate = date;
    }

    cbModifiedBookingDateOnChange(e): void {
        this.isModifiedBookingDate = e.checked;
    }

    downloadTransaction(): void {
        let cfm = confirm("Are you sure you want to download the PTJ Billing Files?");

        if (cfm) {
            this.disabledDownload = true;
            this.downloadMessage = 'System is processing the PTJ Billing Files....';

            let download = {
                Transaction: this.ngr_Transaction,
                BillingFormatId: this.selectedBillingFormat,
                DueDate: this.dueDate,
                ReportDate: this.reportDate,
                Encryption: this.ngrEncryption,
                IsModifiedBookingDate: this.isModifiedBookingDate,
                ModifiedBookingDate: this.modifiedBookingDate
            }

            let transac_sub = this.billingService.downloadStateGovBilling(download)
                .subscribe(
                    (data) => {
                        if (data.status === 204) {
                            this.disabledDownload = false;
                            this.downloadMessage = '';
                            this.openSnackBar('Download failed.', '');
                        } else if (data.status === 200) {
                            let blob = new Blob([data.body], { type: 'application/zip' });
                            saveAs(blob, 'PTJ Billing.zip');

                            this.disabledDownload = false;
                            this.downloadMessage = '';
                            this.dialogRef.close('Download successful');
                        } else {
                            this.disabledDownload = false;
                            this.downloadMessage = '';
                            this.openSnackBar('Download failed.', '');
                        }
                    },
                    error => {
                        this.errorMessage = <any>error;
                        this.disabledDownload = false;
                        this.downloadMessage = '';
                        this.openSnackBar(this.errorMessage, '');
                    });

            //Adds into array for each subscribe
            this.allSub.push(transac_sub);
        }
    }

    ngOnDestroy() {
        for (let sub of this.allSub) {
            sub.unsubscribe();
        }
    }

    openSnackBar(message: string, action: string) {
        this.snackBar.open(message, action, {
            duration: 3000,
        });
    }
}